import { jsx as _jsx } from "react/jsx-runtime";
const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-2",
    lg: "h-10 w-10 border-3",
};
export const Spinner = ({ size = "md", className = "" }) => {
    return (_jsx("span", { role: "status", "aria-label": "Loading", className: `inline-block animate-spin rounded-full border-current border-r-transparent ${sizeClasses[size]} ${className}` }));
};
//# sourceMappingURL=Spinner.js.map